import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLongevityFrontier from "./sections/TheLongevityFrontier";
import ClientLogos from "./sections/ClientLogos";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import Masterproservices from "./sections/Masterproservices";
import SolucoesCorporativas from "./sections/SolucoesCorporativas";
import OurProfessionalTeam from "./sections/OurProfessionalTeam";
import Testimonials from "./sections/Testimonials";
import Faq from "./sections/Faq";
import FaqAccordionCoachingValue from "./sections/FaqAccordionCoachingValue";
import SubmitATip from "./sections/SubmitATip";
import ProductsGrid from "./sections/ProductsGrid";
import PartnersAndExperts from "./sections/PartnersAndExperts";
import FraternalFooter from "@/reusable_sections/Footer";
import TransformationTechnologies from "./sections/TransformationTechnologies";
import IndustryInsights from "./sections/IndustryInsights";
import MasterProEcosystem from "./sections/MasterProEcosystem";
import PulseTransformationMetrics from "./sections/PulseTransformationMetrics";
import IndustryTrustAndSuccess from "./sections/IndustryTrustAndSuccess";
import FromLensToLayout from "./sections/FromLensToLayout";
import TheLineup from "./sections/TheLineup";
import MediaMentions from "./sections/MediaMentions";
import SuccessStories from "./sections/SuccessStories";
import Premiumeditorialservices from "./sections/Premiumeditorialservices";
export default function HomePage() {
  return <div>
      <Header />
      <TheLongevityFrontier />
      <ProductsGrid />
      <ClientLogos />
      <Masterproservices />
      <Premiumeditorialservices />
      <EngineeredForExcellence />
      <PartnersAndExperts />
      <TransformationTechnologies />
      <SolucoesCorporativas />
      <OurProfessionalTeam />
      <Testimonials />
      <Faq />
      <PulseTransformationMetrics />
      <IndustryTrustAndSuccess />
      <FromLensToLayout />
      <MediaMentions />
      <TheLineup />
      <SuccessStories />
      <FaqAccordionCoachingValue />
      <SubmitATip />
      <IndustryInsights />
      <MasterProEcosystem />
      <FraternalFooter />
    </div>;
}